export default {
  addToCartForm: document.querySelectorAll('#AddToCartForm'),
  body: document.body,
  cart: document.querySelector('#cart'),
  cartContent: document.querySelector('#cartContent'),
  cartForm: document.querySelector('#cart form'),
  cartShipping: document.querySelector('#cartFreeShipping'),
  cartSwitch: document.querySelector('#cart-switch'),
  checkoutButton: document.querySelector('input[name="checkout"]'),
  header: document.querySelector('#header'),
  mainAndFooter: document.querySelectorAll('#main, #footer'),
  priceTotal: document.querySelector('#cartTotal'),
  priceTotalUnits: document.querySelector('#cartTotalUnits'),
  radioSubmit: document.querySelectorAll('.s-product__sub-toggle'),
  upsell: document.querySelectorAll('.c-cart__upsell'),
  upsellGarden: document.querySelector('.c-cart__upsell--garden'),
  upsellSpice: document.querySelector('.c-cart__upsell--spice'),
  upsellGrove: document.querySelector('.c-cart__upsell--grove'),
}
